<template>
  <ion-page>
      <ion-header>
          <ion-toolbar>
              <ion-title>&nbsp;</ion-title>
          </ion-toolbar>
      </ion-header>
      <ion-content>
          <ion-refresher slot="fixed" @ionRefresh="refreshStats">
            <ion-refresher-content></ion-refresher-content>
          </ion-refresher>
          <ion-grid class="ion-no-padding">
              <ion-row>
                  <ion-col class="ion-no-padding">
                      <div class="stats">
                            (KZN) <b>Confirmed: {{latest_stats.confirmed}} | Recovered: {{latest_stats.recovered}} | Deaths: {{latest_stats.deaths}}</b>
                        </div>
                  </ion-col>
              </ion-row>
              <ion-row>
                  <ion-col class="ion-no-padding">
                      <img src="../assets/innerbanner.png"/>
                  </ion-col>
              </ion-row>
              <ion-row>
                  <ion-col  @click="$router.push({ name: 'screening' })" class="ion-text-center">
                      <img src="../assets/selfscreening.png"/>
                      <ion-label class="home_label">Self Screening</ion-label>
                  </ion-col>
                  <ion-col @click="$router.push({ name: 'contacts' })" class="ion-text-center">
                      <img src="../assets/contacts.png"/>
                      <ion-label class="home_label">Contacts</ion-label>
                  </ion-col>
                  <ion-col @click="$router.push({ name: 'complaints' })" class="ion-text-center">
                      <img src="../assets/complains.png"/>
                      <ion-label class="home_label">Complaints and Compliments</ion-label>
                  </ion-col>
              </ion-row>
              <ion-row> 
                  <ion-col @click="$router.push({ name: 'followup' })" class="ion-text-center">
                      <img src="../assets/followup.png"/>
                      <ion-label class="home_label">Follow Up</ion-label>
                  </ion-col>
                  <ion-col @click="$router.push({ name: 'facility' })" class="ion-text-center">
                      <img src="../assets/ourfacility.png"/>
                      <ion-label class="home_label">Locate Your Facility</ion-label>
                  </ion-col>
                  <ion-col @click="$router.push({ name: 'volunteer' })" class="ion-text-center">
                      <img src="../assets/volonteer.png"/>
                      <ion-label class="home_label">Volunteer</ion-label>
                  </ion-col>
              </ion-row>
              <ion-row>
                  <ion-col @click="$router.push({ name: 'ambulance' })" class="ion-text-center">
                      <img src="../assets/ambulance.png"/>
                      <ion-label class="home_label">Request Ambulance</ion-label>
                  </ion-col>
                  <ion-col @click="$router.push({ name: 'faq' })" class="ion-text-center">
                      <img src="../assets/faq.png"/>
                      <ion-label class="home_label">FAQs</ion-label>
                  </ion-col>
                  <ion-col  @click="$router.push({ name: 'stats' })" class="ion-text-center">
                      <img src="../assets/stats.png"/>
                      <ion-label class="home_label">Statistics</ion-label>
                  </ion-col>
              </ion-row>
          </ion-grid>
      </ion-content>
  </ion-page>
</template>

<script>
export default {
    name:'home',
    data(){
        return {
            latest_stats:{
                confirmed:0,
                recovered:0,
                deaths:0
            }
        }
    },
    methods:{
        fetchStats(){
            const base_url=this.$store.get('base_url');
            this.$http.get(base_url+'/api/statistics/12')
            .then((res)=>this.latest_stats=res.data)
            .catch((err)=>{console.log(err)});
        },
        refreshStats(ev){
            const base_url=this.$store.get('base_url');
            this.$http.get(base_url+'/api/statistics/12')
            .then((res)=>this.latest_stats=res.data)
            .then(()=>ev.target.complete())
            .catch((err)=>{console.log(err);ev.target.complete()});
        }
    },
    created(){
        this.fetchStats();
    }
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
.home_label{
    font-size: 0.8em;
}
.stats{
    background: #fbc414;
    margin: 0px;
    font-weight: 400;
    font-size: 13px;
    color: white;
    text-align: center;
    padding-top: 4px;
    padding-bottom: 4px;
}
</style>